<template>
    <div class="modalwrapper">
        <div v-if="!exiting">
            <br>
            <h1>
                <font-awesome-icon class="icon" :icon="['fal', 'exclamation-triangle']"/> 
                Exit accrolab
                <font-awesome-icon class="icon" :icon="['fal', 'exclamation-triangle']"/>
            </h1>
            <div class="instruction">
            <h4>Emergency button engaged:</h4>
            1. Exit accrolab by clicking on the 'Abort and Exit' button
            <br>
            2. Power off the accroma 2.0
            <br>
            3. Release the emergency stop button (turn right and pull out)
            <br>
            4. Proceed with the normal system start up (turn on the accroma 2.0 and start the accrolab software)
            </div>
            <br>
            <button @click="exit">Abort and Exit</button> 
        </div>
        <div v-else>
            <h1>Shutting down...</h1>
            <div class="spinner">
                <loading/>
            </div>
        </div>
    </div> 
</template>

<script>

export default {

    methods: {
        exit(){
            this.exiting = true;
            this.$api.call('status.exit');
        }
    },
    components: {
        
    },
    mounted(){
       
    },
    props: [
    ],
    data: function(){
        return {
            exiting: false
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .modalwrapper{
        height: 100%;
        vertical-align: middle;
        margin: auto;
        text-align: center;

    }
    .spinner {
        margin: auto;
        font-size: 50px;
        margin-top: -50px;
    }
    .icon{
        color: $lid-red;
    }
    button {
        width: 49%;
        box-shadow: 2px 2px 5px 0px $accromagrey;
        &:hover:not([disabled]) {
            background-color: $accromabluehue;
        }
    }
    .instruction{
        text-align: left;
        margin-left: 30px;
        margin-right: 30px;
    }
</style>
